import R from 'ramda';
import tabgrouptemplate from './tabGroup.tpl.html';

export class Tabgroup {
  constructor($translate) {
    Object.assign(this, {
      $translate,
    });
  }

  $onInit() {
    const mapIndexed = R.addIndex(R.map);
    const isColumnEmpty = element =>
      !element || R.isNil(element.value) || R.isEmpty(element.value) || element.value === 'NaN';

    const filteredData = (this.data || [])
      .filter(row =>
        !R.values(row)
          .map(column => isColumnEmpty(column))
          .reduce((columnEmpty, rowEmpty) => rowEmpty && columnEmpty));

    this.data = mapIndexed(Tabgroup.addId, filteredData);
    this.selectedTab = this.data[0];
    this.getTabLabel = Tabgroup.getTabLabel;
  }

  selectTab(tab) {
    this.selectedTab = tab;
  }

  isSelected(tab) {
    return this.selectedTab.id === tab.id;
  }

  static getTabLabel(group) {
    let label;
    const labelElement = R.find(R.propEq('header', true), R.values(group));
    if (!labelElement) {
      label = R.values(group)[0].value || 'GENERIC_INSERT';
    } else {
      label = labelElement.value || 'GENERIC_INSERT';
    }
    return label;
  }

  static addId(val, index) {
    val.id = index;
    return val;
  }
}

Tabgroup.$inject = [
  '$translate',
];

export const tabgroup = {
  template: tabgrouptemplate,
  controller: Tabgroup,
  bindings: {
    data: '<',
    keys: '<',
    numColumns: '<',
    cardClass: '<',
  },
};
